// extracted by mini-css-extract-plugin
module.exports = {"button":"ZenDeskChatButton_button__pX7_h","backgroundColorPaper":"ZenDeskChatButton_backgroundColorPaper__uSgje","countBadge":"ZenDeskChatButton_countBadge__lEaa3"};